












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseProfilExclusion from '@/components/profilExclusion/edit/EditBaseProfilExclusion.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import * as rules from '@/utils/validationRules'

@Component({
  name: 'EditConfig',    
  components:{EditBaseProfilExclusion},  
  props: {   
  }      
})
export default class EditConfig extends Vue {
  
  private profilExclusion = getDefaultAloProfilExclusion()
    
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloProfilExclusion) {            
    this.profilExclusion =  (this.$refs.baseEdit as EditBaseProfilExclusion).edit(item)  
  }  
  
}
